// extracted by mini-css-extract-plugin
export default {"treeInput":"FlatTreeInput_treeInput__4bzcE"};